import { currentAppEnv } from 'utils/appEnv';
import { safeLocalStorage } from 'utils/safeStorage';
const readDeveloperEnvOverride = (storageKey) => {
    if (currentAppEnv() === 'production')
        return {};
    try {
        const storedOverride = JSON.parse(safeLocalStorage.getItem(storageKey) || '{}');
        return storedOverride && typeof storedOverride === 'object'
            ? storedOverride
            : {};
    }
    catch (error) {
        return {};
    }
};
export { readDeveloperEnvOverride };
